import React from 'react';
import {Row, Col, Button} from "react-bootstrap";
import style from './Announcement.module.scss';
import OwlCarousel from 'react-owl-carousel';
import * as announcementActions from "../../../../redux/action/announcement.action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {BASE_URL} from "../../../../environment/environment";
import * as urls from "../../../../config/urls";

class Announcement extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      announcements: []
    }
  }

  async componentDidMount() {
    this.fetchAnnouncements();
  }

  async fetchAnnouncements() {
    try {
      const announcements = await this.props.fetchAnnouncements();
      this.setState({announcements});
    } catch (e) { }
  }

  render() {
    const { announcements } = this.state;
    return (
      <div className={`${style.announcement_container}`}>
        <h2 className={'section-title'}>بیشتر بدانیم</h2>
        <Row>
          <Col xs={12}>
            {
              announcements && !!announcements.length && (
                  <OwlCarousel
                      className="owl-theme"
                      loop
                      margin={10}
                      nav={false}
                      items={1}
                  >
                    {
                      announcements.map((announcement) => {
                        return (
                            <div key={announcement.id} className={`${style.box}`}>
                              <div className={`text-right ${style.content}`}>
                                <div>
                                  <span className={`${style.title}`}>{announcement.title}</span>
                                </div>
                                <div className={`${style.description}`}>
                                  <span>{announcement.summary}</span>
                                </div>
                                <Button variant={'primary'} onClick={() => {
                                  this.props.history.push(`/announcement/${announcement.id}`);
                                }}>ادامه مطلب</Button>
                              </div>
                              <div className={`${style.image}`}>
                                <img src={`${BASE_URL}${urls.FILE_BY_UUID}/${announcement.file}`} alt="file" className={'d-none d-md-block'} />
                              </div>
                            </div>
                        )
                      })
                    }
                  </OwlCarousel>
              )
            }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  fetchAnnouncements: () => dispatch(announcementActions.fetchAnnouncements()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Announcement));
